// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  padding: 20px;
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
}
.auth-container .auth-card {
  width: 100%;
  max-width: 380px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  background: white;
  border-radius: 0px !important;
}
.auth-container .auth-card.signup-card {
  max-width: 420px;
}
.auth-container .auth-card .ant-card-body {
  padding: 24px;
}
@media (max-width: 768px) {
  .auth-container .auth-card .ant-card-body {
    padding: 20px;
  }
}
.auth-container .auth-card .ant-segmented .ant-segmented-item-selected {
  background-color: #0576b7 !important;
  color: #ffffff !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-container .auth-card .ant-segmented .ant-segmented-item {
  border-radius: 0px !important;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-container .auth-header {
  text-align: center;
  margin-bottom: 20px;
}
.auth-container .auth-header .auth-title {
  color: #0576b7;
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-weight: 600;
  margin-bottom: 4px !important;
  font-size: 20px;
}
@media (max-width: 768px) {
  .auth-container .auth-header .auth-title {
    font-size: 18px;
  }
}
.auth-container .auth-header .auth-subtitle {
  color: #6b7280;
  font-size: 14px;
}
@media (max-width: 768px) {
  .auth-container .auth-header .auth-subtitle {
    font-size: 13px;
  }
}
.auth-container .auth-form .ant-form-item-label > label {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}
.auth-container .auth-form .ant-input {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: none !important;
}
.auth-container .auth-form .ant-input:focus, .auth-container .auth-form .ant-input.ant-input-focused {
  border-color: #0576b7;
  box-shadow: none !important;
  outline: none;
}
.auth-container .auth-form .ant-input:hover {
  border-color: #0576b7;
}
.auth-container .auth-form .ant-input .ant-input-prefix {
  color: #6b7280;
  margin-right: 8px;
}
.auth-container .auth-form .ant-input-password {
  border-radius: 6px;
  border: 1px solid #d1d5db;
  padding: 8px 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-shadow: none !important;
}
.auth-container .auth-form .ant-input-password:focus, .auth-container .auth-form .ant-input-password.ant-input-focused {
  border-color: #0576b7;
  box-shadow: none !important;
  outline: none;
}
.auth-container .auth-form .ant-input-password:hover {
  border-color: #0576b7;
}
.auth-container .auth-form .ant-input-password .ant-input-prefix {
  color: #6b7280;
  margin-right: 8px;
}
.auth-container .auth-form .ant-input-password .ant-input {
  border: none;
  box-shadow: none;
  padding: 0;
}
.auth-container .auth-form .ant-input-password .ant-input:focus, .auth-container .auth-form .ant-input-password .ant-input.ant-input-focused {
  border: none;
  box-shadow: none;
}
.auth-container .auth-form .phone-input {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}
.auth-container .auth-form .phone-input:focus-within {
  border-color: #0576b7;
}
.auth-container .auth-form .phone-input:hover {
  border-color: #0576b7;
}
.auth-container .auth-form .phone-input .PhoneInputInput {
  border: none;
  padding: 0;
  font-size: 14px;
  width: 100%;
  outline: none;
  background: transparent;
}
.auth-container .auth-form .phone-input .PhoneInputInput:focus {
  border: none;
  box-shadow: none;
  outline: none;
}
.auth-container .auth-form .phone-input .PhoneInputCountrySelect {
  border: none;
  margin-right: 8px;
  padding: 0;
  font-size: 14px;
  background: transparent;
}
.auth-container .auth-form .phone-input .PhoneInputCountrySelect:focus {
  border: none;
  outline: none;
}
.auth-container .auth-form .ant-form-item-explain-error {
  font-size: 12px;
  color: #ef4444;
  margin-top: 4px;
}
.auth-container .auth-submit {
  margin-bottom: 24px !important;
}
.auth-container .auth-submit .auth-button {
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);
  border: none;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(5, 118, 183, 0.3);
  transition: all 0.3s ease;
}
.auth-container .auth-submit .auth-button:hover, .auth-container .auth-submit .auth-button:focus {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(5, 118, 183, 0.4);
  background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);
}
.auth-container .auth-submit .auth-button:active {
  transform: translateY(0);
}
.auth-container .auth-submit .auth-button.ant-btn-loading {
  transform: none;
}
.auth-container .auth-footer {
  text-align: center;
  border-top: 1px solid #f3f4f6;
  padding-top: 24px;
}
.auth-container .auth-footer .ant-typography {
  color: #6b7280;
  font-size: 14px;
}
.auth-container .auth-footer .auth-link {
  color: #0576b7;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.3s ease;
}
.auth-container .auth-footer .auth-link:hover {
  color: #4a90e2;
  text-decoration: underline;
}
.auth-container .instructions-trigger {
  font-size: 13px !important;
}
.auth-container .instructions-trigger:hover {
  text-decoration: underline !important;
}

@media (max-width: 768px) {
  .auth-container {
    padding: 16px;
  }
  .auth-container .auth-card .ant-card-body {
    padding: 24px 20px;
  }
  .auth-container .auth-header {
    margin-bottom: 24px;
  }
}
.auth-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.w-100 {
  width: 100%;
}

.login-instructions-modal .ant-modal-header {
  border-radius: 0 !important;
  text-align: center;
  padding: 20px 24px 12px;
}
.login-instructions-modal .ant-modal-header .modal-title-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.login-instructions-modal .ant-modal-header .modal-title-center .modal-main-title {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-weight: 700;
  color: #0576b7;
  font-size: 20px;
  margin: 0;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-header .modal-title-center .modal-main-title {
    font-size: 18px;
  }
}
.login-instructions-modal .ant-modal-header .modal-title-center .modal-subtitle {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  color: #e67e22;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-header .modal-title-center .modal-subtitle {
    font-size: 14px;
  }
}
.login-instructions-modal .ant-modal-content {
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.login-instructions-modal .ant-modal-body {
  padding: 16px 24px 24px;
  text-align: center;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns {
  display: flex;
  gap: 28px;
  align-items: stretch;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .modal-col {
  flex: 1 1;
  min-width: 0;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .modal-col-right {
  border-left: 1px solid #e2e8f0;
  padding-left: 24px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .queries-section,
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .support-section {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .support-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns {
    flex-direction: column;
    gap: 0;
  }
  .login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .modal-col-right {
    border-left: none;
    padding-left: 0;
  }
  .login-instructions-modal .ant-modal-body .modal-welcome-content .modal-columns .queries-section {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
  }
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .welcome-message {
  margin-bottom: 16px;
  padding: 14px 16px;
  background: #f8f9fa;
  border-radius: 8px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .welcome-message .welcome-text {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 15px;
  line-height: 1.6;
  color: #2d3748;
  margin: 0;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .welcome-message .welcome-text {
    font-size: 14px;
  }
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section {
  text-align: left;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .steps-title {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 16px;
  color: #2d3748;
  margin-bottom: 12px;
  display: block;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .steps-title {
    font-size: 15px;
  }
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .step-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  padding: 4px 0;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .step-item:last-child {
  margin-bottom: 0;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .step-item .step-number {
  background: #0576b7;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  margin-right: 12px;
  flex-shrink: 0;
  margin-top: 2px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .step-item .step-text {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #4a5568;
  margin: 0;
  flex: 1 1;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .steps-section .step-item .step-text {
    font-size: 13px;
  }
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section {
  text-align: left;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .steps-title,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .steps-title {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 15px;
  color: #2d3748;
  margin-bottom: 8px;
  display: block;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .contact-numbers,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .contact-numbers {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .step-text,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .step-text {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: #4a5568;
  display: block;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .step-text a,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .step-text a {
  color: #0576b7;
  text-decoration: none;
  font-weight: 600;
  white-space: nowrap;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .step-text a:hover,
.login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .step-text a:hover {
  text-decoration: underline;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .queries-section .step-text,
  .login-instructions-modal .ant-modal-body .modal-welcome-content .support-section .step-text {
    font-size: 13px;
  }
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section {
  text-align: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e2e8f0;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .step-text {
  margin-bottom: 12px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .steps-title {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 16px;
  color: #0576b7;
  margin-bottom: 8px;
  display: block;
  font-weight: 700;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .step-text {
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-size: 14px;
  color: #6b7280;
  display: block;
  margin-bottom: 16px;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .app-store-buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .app-store-buttons a {
  display: inline-block;
  transition: transform 0.2s ease;
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .app-store-buttons a:hover {
  transform: translateY(-2px);
}
.login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .app-store-buttons .store-badge {
  height: 44px;
}
@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body .modal-welcome-content .app-download-section .app-store-buttons .store-badge {
    height: 40px;
  }
}
.login-instructions-modal .ant-modal-footer {
  border-radius: 0 !important;
  text-align: center;
  padding: 16px 24px 24px;
}
.login-instructions-modal .ant-modal-footer .ant-btn-primary {
  border-radius: 6px !important;
  background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);
  border: none;
  font-family: "NotoSansMalayalam-SemiBold", Arial, sans-serif;
  font-weight: 600;
  padding: 8px 32px;
  height: 44px;
  font-size: 14px;
}
.login-instructions-modal .ant-modal-footer .ant-btn-primary:hover {
  background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(5, 118, 183, 0.3);
}

@media (max-width: 768px) {
  .login-instructions-modal .ant-modal-body {
    padding: 16px 20px;
  }
  .login-instructions-modal .ant-modal-body .modal-instructions-content .instruction-item {
    padding: 10px 0;
  }
  .login-instructions-modal .ant-modal-body .modal-instructions-content .instruction-item .instruction-icon {
    font-size: 14px;
    margin-right: 10px;
  }
  .login-instructions-modal .ant-modal-body .modal-instructions-content .instruction-item .instruction-text .ant-typography.ant-typography-caption {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/auth/AuthForms.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,4DAAA;AAAF;AAEE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;AAAJ;AAEI;EACE,gBAAA;AAAN;AAGI;EACE,aAAA;AADN;AAGM;EAHF;IAII,aAAA;EAAN;AACF;AAKM;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAKM;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHR;AAQE;EACE,kBAAA;EACA,mBAAA;AANJ;AAQI;EACE,cAAA;EACA,4DAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;AANN;AAQM;EAPF;IAQI,eAAA;EALN;AACF;AAQI;EACE,cAAA;EACA,eAAA;AANN;AAQM;EAJF;IAKI,eAAA;EALN;AACF;AAUI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AARN;AAWI;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;AATN;AAWM;EAEE,qBAAA;EACA,2BAAA;EACA,aAAA;AAVR;AAaM;EACE,qBAAA;AAXR;AAcM;EACE,cAAA;EACA,iBAAA;AAZR;AAgBI;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;AAdN;AAgBM;EAEE,qBAAA;EACA,2BAAA;EACA,aAAA;AAfR;AAkBM;EACE,qBAAA;AAhBR;AAmBM;EACE,cAAA;EACA,iBAAA;AAjBR;AAsBM;EACE,YAAA;EACA,gBAAA;EACA,UAAA;AApBR;AAsBQ;EAEE,YAAA;EACA,gBAAA;AArBV;AA2BI;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAzBN;AA2BM;EACE,qBAAA;AAzBR;AA4BM;EACE,qBAAA;AA1BR;AA6BM;EACE,YAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA3BR;AA6BQ;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AA3BV;AA+BM;EACE,YAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,uBAAA;AA7BR;AA+BQ;EACE,YAAA;EACA,aAAA;AA7BV;AAkCI;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAhCN;AAoCE;EACE,8BAAA;AAlCJ;AAoCI;EACE,YAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;EACA,yBAAA;AAlCN;AAoCM;EAEE,2BAAA;EACA,6CAAA;EACA,6DAAA;AAnCR;AAsCM;EACE,wBAAA;AApCR;AAuCM;EACE,eAAA;AArCR;AA0CE;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;AAxCJ;AA0CI;EACE,cAAA;EACA,eAAA;AAxCN;AA2CI;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;AAzCN;AA2CM;EACE,cAAA;EACA,0BAAA;AAzCR;AA+CE;EACE,0BAAA;AA7CJ;AA+CI;EACE,qCAAA;AA7CN;;AAmDA;EACE;IACE,aAAA;EAhDF;EAkDE;IACE,kBAAA;EAhDJ;EAmDE;IACE,mBAAA;EAjDJ;AACF;AAsDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AApDF;;AAwDA;EACE,WAAA;AArDF;;AA0DE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;AAvDJ;AAyDI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AAvDN;AAyDM;EACE,4DAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;AAvDR;AAyDQ;EAPF;IAQI,eAAA;EAtDR;AACF;AAyDM;EACE,4DAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAvDR;AAyDQ;EAPF;IAQI,eAAA;EAtDR;AACF;AA2DE;EACE,6BAAA;EACA,0CAAA;EACA,gBAAA;AAzDJ;AA4DE;EACE,uBAAA;EACA,kBAAA;AA1DJ;AA6DM;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AA3DR;AA6DQ;EACE,SAAA;EACA,YAAA;AA3DV;AA8DQ;EACE,8BAAA;EACA,kBAAA;AA5DV;AAgEQ;;EAEE,aAAA;EACA,cAAA;EACA,gBAAA;AA9DV;AAiEQ;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AA/DV;AAkEQ;EA7BF;IA8BI,sBAAA;IACA,MAAA;EA/DR;EAiEQ;IACE,iBAAA;IACA,eAAA;EA/DV;EAkEQ;IACE,gBAAA;IACA,iBAAA;IACA,6BAAA;EAhEV;AACF;AAoEM;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAlER;AAoEQ;EACE,4DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAlEV;AAoEU;EAPF;IAQI,eAAA;EAjEV;AACF;AAqEM;EACE,gBAAA;AAnER;AAqEQ;EACE,4DAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAnEV;AAqEU;EAPF;IAQI,eAAA;EAlEV;AACF;AAqEQ;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AAnEV;AAqEU;EACE,gBAAA;AAnEZ;AAsEU;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AApEZ;AAuEU;EACE,4DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;AArEZ;AAuEY;EARF;IASI,eAAA;EApEZ;AACF;AAyEM;;EAEE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAvER;AAyEQ;;EACE,4DAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AAtEV;AAyEQ;;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtEV;AAyEQ;;EACE,4DAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAtEV;AAwEU;;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AArEZ;AAuEY;;EACE,0BAAA;AApEd;AAwEU;EAlBF;;IAmBI,eAAA;EApEV;AACF;AAwEM;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAtER;AAwEQ;EACE,mBAAA;AAtEV;AAyEQ;EACE,4DAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAvEV;AA0EQ;EACE,4DAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;AAxEV;AA2EQ;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAzEV;AA2EU;EACE,qBAAA;EACA,+BAAA;AAzEZ;AA2EY;EACE,2BAAA;AAzEd;AA6EU;EACE,YAAA;AA3EZ;AA6EY;EAHF;IAII,YAAA;EA1EZ;AACF;AAiFE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;AA/EJ;AAiFI;EACE,6BAAA;EACA,6DAAA;EACA,YAAA;EACA,4DAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AA/EN;AAiFM;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AA/ER;;AAqFA;EAEI;IACE,kBAAA;EAnFJ;EAsFM;IACE,eAAA;EApFR;EAsFQ;IACE,eAAA;IACA,kBAAA;EApFV;EAyFY;IACE,eAAA;EAvFd;AACF","sourcesContent":["// Auth Forms Styles\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f5f5f5;\n  padding: 20px;\n  font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n\n  .auth-card {\n    width: 100%;\n    max-width: 380px;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e0e0e0;\n    background: white;\n    border-radius: 0px !important;\n\n    &.signup-card {\n      max-width: 420px;\n    }\n\n    .ant-card-body {\n      padding: 24px;\n\n      @media (max-width: 768px) {\n        padding: 20px;\n      }\n    }\n\n    // Styling for Segmented control inside auth-card\n    .ant-segmented {\n      .ant-segmented-item-selected {\n        background-color: #0576b7 !important; // Primary color\n        color: #ffffff !important; // White text for contrast\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      .ant-segmented-item {\n        border-radius: 0px !important; // Match button style\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n  }\n\n  .auth-header {\n    text-align: center;\n    margin-bottom: 20px;\n\n    .auth-title {\n      color: #0576b7;\n      font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n      font-weight: 600;\n      margin-bottom: 4px !important;\n      font-size: 20px;\n\n      @media (max-width: 768px) {\n        font-size: 18px;\n      }\n    }\n\n    .auth-subtitle {\n      color: #6b7280;\n      font-size: 14px;\n\n      @media (max-width: 768px) {\n        font-size: 13px;\n      }\n    }\n  }\n\n  .auth-form {\n    .ant-form-item-label > label {\n      font-weight: 600;\n      color: #374151;\n      font-size: 14px;\n    }\n\n    .ant-input {\n      border-radius: 6px;\n      border: 1px solid #d1d5db;\n      padding: 8px 12px;\n      font-size: 14px;\n      transition: all 0.3s ease;\n      box-shadow: none !important;\n\n      &:focus,\n      &.ant-input-focused {\n        border-color: #0576b7;\n        box-shadow: none !important;\n        outline: none;\n      }\n\n      &:hover {\n        border-color: #0576b7;\n      }\n\n      .ant-input-prefix {\n        color: #6b7280;\n        margin-right: 8px;\n      }\n    }\n\n    .ant-input-password {\n      border-radius: 6px;\n      border: 1px solid #d1d5db;\n      padding: 8px 12px;\n      font-size: 14px;\n      transition: all 0.3s ease;\n      box-shadow: none !important;\n\n      &:focus,\n      &.ant-input-focused {\n        border-color: #0576b7;\n        box-shadow: none !important;\n        outline: none;\n      }\n\n      &:hover {\n        border-color: #0576b7;\n      }\n\n      .ant-input-prefix {\n        color: #6b7280;\n        margin-right: 8px;\n      }\n    }\n\n    .ant-input-password {\n      .ant-input {\n        border: none;\n        box-shadow: none;\n        padding: 0;\n\n        &:focus,\n        &.ant-input-focused {\n          border: none;\n          box-shadow: none;\n        }\n      }\n    }\n\n    // Phone input styling\n    .phone-input {\n      border: 1px solid #d1d5db;\n      border-radius: 6px;\n      padding: 8px 12px;\n      display: flex;\n      align-items: center;\n      transition: all 0.3s ease;\n\n      &:focus-within {\n        border-color: #0576b7;\n      }\n\n      &:hover {\n        border-color: #0576b7;\n      }\n\n      .PhoneInputInput {\n        border: none;\n        padding: 0;\n        font-size: 14px;\n        width: 100%;\n        outline: none;\n        background: transparent;\n\n        &:focus {\n          border: none;\n          box-shadow: none;\n          outline: none;\n        }\n      }\n\n      .PhoneInputCountrySelect {\n        border: none;\n        margin-right: 8px;\n        padding: 0;\n        font-size: 14px;\n        background: transparent;\n\n        &:focus {\n          border: none;\n          outline: none;\n        }\n      }\n    }\n\n    .ant-form-item-explain-error {\n      font-size: 12px;\n      color: #ef4444;\n      margin-top: 4px;\n    }\n  }\n\n  .auth-submit {\n    margin-bottom: 24px !important;\n\n    .auth-button {\n      height: 48px;\n      border-radius: 8px;\n      background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);\n      border: none;\n      font-size: 16px;\n      font-weight: 600;\n      box-shadow: 0 4px 12px rgba(5, 118, 183, 0.3);\n      transition: all 0.3s ease;\n\n      &:hover,\n      &:focus {\n        transform: translateY(-2px);\n        box-shadow: 0 6px 16px rgba(5, 118, 183, 0.4);\n        background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);\n      }\n\n      &:active {\n        transform: translateY(0);\n      }\n\n      &.ant-btn-loading {\n        transform: none;\n      }\n    }\n  }\n\n  .auth-footer {\n    text-align: center;\n    border-top: 1px solid #f3f4f6;\n    padding-top: 24px;\n\n    .ant-typography {\n      color: #6b7280;\n      font-size: 14px;\n    }\n\n    .auth-link {\n      color: #0576b7;\n      font-weight: 600;\n      text-decoration: none;\n      transition: color 0.3s ease;\n\n      &:hover {\n        color: #4a90e2;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  // Instructions trigger link styling\n  .instructions-trigger {\n    font-size: 13px !important;\n\n    &:hover {\n      text-decoration: underline !important;\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .auth-container {\n    padding: 16px;\n\n    .auth-card .ant-card-body {\n      padding: 24px 20px;\n    }\n\n    .auth-header {\n      margin-bottom: 24px;\n    }\n  }\n}\n\n// Loading overlay\n.auth-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n// Utility classes\n.w-100 {\n  width: 100%;\n}\n\n// Login Instructions Modal Styling\n.login-instructions-modal {\n  .ant-modal-header {\n    border-radius: 0 !important;\n    text-align: center;\n    padding: 20px 24px 12px;\n\n    .modal-title-center {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 8px;\n\n      .modal-main-title {\n        font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n        font-weight: 700;\n        color: #0576b7;\n        font-size: 20px;\n        margin: 0;\n\n        @media (max-width: 768px) {\n          font-size: 18px;\n        }\n      }\n\n      .modal-subtitle {\n        font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n        color: #e67e22;\n        font-size: 16px;\n        font-weight: 600;\n        margin: 0;\n\n        @media (max-width: 768px) {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n\n  .ant-modal-content {\n    border-radius: 8px !important;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    overflow: hidden;\n  }\n\n  .ant-modal-body {\n    padding: 16px 24px 24px;\n    text-align: center;\n\n    .modal-welcome-content {\n      .modal-columns {\n        display: flex;\n        gap: 28px;\n        align-items: stretch;\n\n        .modal-col {\n          flex: 1 1 0;\n          min-width: 0;\n        }\n\n        .modal-col-right {\n          border-left: 1px solid #e2e8f0;\n          padding-left: 24px;\n        }\n\n        // Sections inside columns shouldn't carry their stand-alone dividers\n        .queries-section,\n        .support-section {\n          margin-top: 0;\n          padding-top: 0;\n          border-top: none;\n        }\n\n        .support-section {\n          margin-top: 16px;\n          padding-top: 16px;\n          border-top: 1px solid #e2e8f0;\n        }\n\n        @media (max-width: 768px) {\n          flex-direction: column;\n          gap: 0;\n\n          .modal-col-right {\n            border-left: none;\n            padding-left: 0;\n          }\n\n          .queries-section {\n            margin-top: 20px;\n            padding-top: 16px;\n            border-top: 1px solid #e2e8f0;\n          }\n        }\n      }\n\n      .welcome-message {\n        margin-bottom: 16px;\n        padding: 14px 16px;\n        background: #f8f9fa;\n        border-radius: 8px;\n\n        .welcome-text {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 15px;\n          line-height: 1.6;\n          color: #2d3748;\n          margin: 0;\n\n          @media (max-width: 768px) {\n            font-size: 14px;\n          }\n        }\n      }\n\n      .steps-section {\n        text-align: left;\n\n        .steps-title {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 16px;\n          color: #2d3748;\n          margin-bottom: 12px;\n          display: block;\n\n          @media (max-width: 768px) {\n            font-size: 15px;\n          }\n        }\n\n        .step-item {\n          display: flex;\n          align-items: flex-start;\n          margin-bottom: 8px;\n          padding: 4px 0;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n\n          .step-number {\n            background: #0576b7;\n            color: white;\n            border-radius: 50%;\n            width: 24px;\n            height: 24px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 12px;\n            font-weight: bold;\n            margin-right: 12px;\n            flex-shrink: 0;\n            margin-top: 2px;\n          }\n\n          .step-text {\n            font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n            font-size: 14px;\n            line-height: 1.5;\n            color: #4a5568;\n            margin: 0;\n            flex: 1;\n\n            @media (max-width: 768px) {\n              font-size: 13px;\n            }\n          }\n        }\n      }\n\n      .queries-section,\n      .support-section {\n        text-align: left;\n        margin-top: 16px;\n        padding-top: 12px;\n        border-top: 1px solid #e2e8f0;\n\n        .steps-title {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 15px;\n          color: #2d3748;\n          margin-bottom: 8px;\n          display: block;\n        }\n\n        .contact-numbers {\n          display: flex;\n          flex-direction: column;\n          gap: 4px;\n        }\n\n        .step-text {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 14px;\n          line-height: 1.5;\n          color: #4a5568;\n          display: block;\n\n          a {\n            color: #0576b7;\n            text-decoration: none;\n            font-weight: 600;\n            white-space: nowrap;\n\n            &:hover {\n              text-decoration: underline;\n            }\n          }\n\n          @media (max-width: 768px) {\n            font-size: 13px;\n          }\n        }\n      }\n\n      .app-download-section {\n        text-align: center;\n        margin-top: 20px;\n        padding-top: 16px;\n        border-top: 1px solid #e2e8f0;\n\n        .step-text {\n          margin-bottom: 12px;\n        }\n\n        .steps-title {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 16px;\n          color: #0576b7;\n          margin-bottom: 8px;\n          display: block;\n          font-weight: 700;\n        }\n\n        .step-text {\n          font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n          font-size: 14px;\n          color: #6b7280;\n          display: block;\n          margin-bottom: 16px;\n        }\n\n        .app-store-buttons {\n          display: flex;\n          justify-content: center;\n          gap: 12px;\n          flex-wrap: wrap;\n\n          a {\n            display: inline-block;\n            transition: transform 0.2s ease;\n\n            &:hover {\n              transform: translateY(-2px);\n            }\n          }\n\n          .store-badge {\n            height: 44px;\n\n            @media (max-width: 768px) {\n              height: 40px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .ant-modal-footer {\n    border-radius: 0 !important;\n    text-align: center;\n    padding: 16px 24px 24px;\n\n    .ant-btn-primary {\n      border-radius: 6px !important;\n      background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);\n      border: none;\n      font-family: \"NotoSansMalayalam-SemiBold\", Arial, sans-serif;\n      font-weight: 600;\n      padding: 8px 32px;\n      height: 44px;\n      font-size: 14px;\n\n      &:hover {\n        background: linear-gradient(135deg, #0576b7 0%, #4a90e2 100%);\n        transform: translateY(-1px);\n        box-shadow: 0 6px 16px rgba(5, 118, 183, 0.3);\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .login-instructions-modal {\n    .ant-modal-body {\n      padding: 16px 20px;\n\n      .modal-instructions-content {\n        .instruction-item {\n          padding: 10px 0;\n\n          .instruction-icon {\n            font-size: 14px;\n            margin-right: 10px;\n          }\n\n          .instruction-text {\n            .ant-typography {\n              &.ant-typography-caption {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
